"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.types18 = void 0;
const types_17_1 = require("./types_17");
exports.types18 = Object.assign(Object.assign({}, types_17_1.types17), { 
    // Remove old DID types
    DidCreationOperation: undefined, DidUpdateOperation: undefined, DidDeletionOperation: undefined, 
    // DID management update
    DidCreationDetails: {
        did: "DidIdentifierOf",
        newKeyAgreementKeys: "BTreeSet<DidEncryptionKey>",
        newAttestationKey: "Option<DidVerificationKey>",
        newDelegationKey: "Option<DidVerificationKey>",
        newEndpointUrl: "Option<Url>",
    }, DidUpdateDetails: {
        newAuthenticationKey: "Option<DidVerificationKey>",
        newKeyAgreementKeys: "BTreeSet<DidEncryptionKey>",
        attestationKeyUpdate: "DidVerificationKeyUpdateAction",
        delegationKeyUpdate: "DidVerificationKeyUpdateAction",
        publicKeysToRemove: "BTreeSet<KeyIdOf>",
        newEndpointUrl: "Option<Url>",
    } });
